<template>
  <module-configuration :data="config" :errors="errors" @save="fetchOrderStatuses">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Url do painel de administração">
        <input class="form-input" placeholder="www.seusite.com.br/wm-admin" v-model="config.auth.url">
      </form-group>
      <form-group label="Token" :error="getError('auth.token')">
        <input class="form-input" placeholder="Digite seu token" v-model="config.auth.token">
        <small class="form-help">Esse token pode ser encontrado no painel administrativo da Moovin.</small>
      </form-group>
    </div>
    <div>
      <panel title="Configurações Gerais">
      <div class="l-row">
        <form-group label="Nome da Loja">
          <input class="form-input" placeholder="MinhaLoja" v-model="config.general.origin">
        </form-group>
        <form-group label="Máscara dos Telefones">
          <select class="form-select" v-model="config.general.phoneMask">
            <option :value="null">(51) 999999999</option>
            <option value="(51) 9 9999-9999">(51) 9 9999-9999</option>
            <option value="(51) 99999-9999">(51) 99999-9999</option>
            <option value="(51) 99999 9999">(51) 99999 9999</option>
            <option value="(51)999999999">(51)999999999</option>
            <option value="51 999999999">51 999999999</option>
            <option value="51 9 9999-9999">51 9 9999-9999</option>
            <option value="51 99999-9999">51 99999-9999</option>
            <option value="51 99999 9999">51 99999 9999</option>
            <option value="51999999999">51999999999</option>
          </select>
          <small class="form-help">Esta configuração informa o padrão do formato dos números de telefone nos pedidos, além disto, caso algum telefone venha sem a informação ou incompleto o mesmo será substituído pela máscara selecionada. Padrão: (51) 999999999</small>
        </form-group>
      </div>
      </panel>
      <panel title="Notificações">
        <div class="l-row">
          <form-group label="URL" :columns="12">
            {{ urlNotification }}

            <button type="button" @click="copied()" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar" v-clipboard:copy="urlNotification">
              <i class="icon icon-copy2"></i>
            </button>
          </form-group>
        </div>
      </panel>
    </div>
    <div>
      <panel title="Produtos">
        <loader :loading="loading"/>

        <div class="l-row" v-if="!loading">
          <form-group label="Sincronizar produtos automaticamente">
            <label class="form-switch">
              <input type="checkbox" v-model="config.product.synchronize">
              <span class="form-switch__indicator"></span>
            </label>
            <small class="form-help">Define se os produtos da fonte de dados devem ser sincronizados automaticamente.</small>
          </form-group>

          <form-group label="Sincronizar apenas produtos ativos">
            <label class="form-switch">
              <input type="checkbox" v-model="config.product.lookupOnlyStatusActive">
              <span class="form-switch__indicator"></span>
            </label>
            <small class="form-help">Define se apenas produtos ativos na fonte de dados devem ser sincronizados.</small>
          </form-group>
        </div>

        <form-group label="Utilizar versão 2.0 de envio de estoques">
          <label class="form-switch">
            <input type="checkbox" v-model="config.product.stockV2">
            <span class="form-switch__indicator"></span>
          </label>
          <small class="form-help">* Marcar apenas para lojas teste</small>
        </form-group>

        <div class="l-row" v-if="!loading">
          <form-group label="Formato da cor">
            <select v-model="config.product.formatColor" class="form-select">
              <option value="colors">Cor Primária/Cor Secundária</option>
              <option value="manufacturerColor">Cor fabricante padrão Placemarket</option>
              <option value="manufacturerColorSource">Cor fabricante padrão Moovin</option>
            </select>
            <small class="form-help">O padrão Placemarket irá trocar a "/" por ", ".</small>
          </form-group>

          <form-group label="Tipo da imagem">
            <select v-model="config.product.imageType" class="form-select">
              <option v-for="imageType in imageTypes" :key="imageType.value" :value="imageType.value">{{ imageType.label }}</option>
            </select>
            <small class="form-help">O padrão Placemarket é original.</small>
          </form-group>
        </div>
      </panel>
    </div>

    <panel title="Status de pedidos">
      <loader :loading="loading"/>

      <div slot="header-right">
        <a href="#" @click="fetchOrderStatuses()" class="btn btn--info"><i class="icon-spinner11"></i></a>
      </div>

      <div class="l-row" v-if="fetched">
        <form-group :label="$t(`${statusName}.label`)" v-for="(statusValue, statusName) in getStatusByIdentifier('default')" :key="statusName" v-if="statusName !== 'identifier'">
          <select v-model="getStatusByIdentifier('default')[statusName]" class="form-select">
            <option :value="null">Selecione</option>
            <option v-for="status in statusesGroupedByType[(statusName === 'refunded')? 'delivered' : statusName]" :key="status.code" :value="status.code">{{ status.label }}</option>
            <option v-if="statusName === 'refunded'" v-for="status in statusesGroupedByType['canceled']" :key="status.code" :value="status.code">{{ status.label }}</option>
          </select>
        </form-group>
      </div>

      <div v-else-if="!fetching" class="u-bolder t-error u-textCenter">Não foi possível buscar os status dos pedidos da Moovin.</div>
    </panel>

    <panel title="Status de pedidos por marketplace">
      <div slot="header-right">
        <a href="#" @click="fetchOrderStatuses()" class="btn btn--info"><i class="icon-spinner11"></i></a>
      </div>

      <loader :loading="loading"/>

      <panel :title="module.name" v-for="module in modulesInstalled" :key="module" :useAcordion="true" :useToggleIcon="true" class="blue-panel">
        <panel>
          <div class="l-row" v-if="fetched">
            <form-group :label="$t(`${statusName}.label`)" v-for="(statusValue, statusName) in getStatusByIdentifier(module.identifier)" :key="statusName" v-if="statusName !== 'identifier' && statusName !== 'exchange'">
              <select v-model="getStatusByIdentifier(module.identifier)[statusName]" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="status in statusesGroupedByType[statusName]" :key="status.code" :value="status.code">{{ status.label }}</option>
              </select>
            </form-group>
            <form-group :label="$t(`exchange.${statusName}.label`)" v-for="(statusValue, statusName) in getExchangeStatusByIdentifier(module.identifier)" :key="statusName" v-if="haveExchangeStatuses(module.identifier)">
              <select v-model="getExchangeStatusByIdentifier(module.identifier)[statusName]" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="status in statusesGroupedByType[statusName]" :key="status.code" :value="status.code">{{ status.label }}</option>
              </select>
            </form-group>
          </div>

          <div v-else-if="!fetching" class="u-bolder t-error u-textCenter">Não foi possível buscar os status dos pedidos da Moovin.</div>
        </panel>
      </panel>
    </panel>
  </module-configuration>
</template>

<script>
  import { union } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import { groupBy, prop } from 'ramda'
  import api from '@/api'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import cookie from 'vue-cookie'
  import notifier from '@/notifier'

  export default {
    provide: {
      moduleDI: {
        type: 'ecommerce',
        identifier: 'moovin'
      }
    },
    data: () => ({
      loading: false,
      type: 'ecommerce',
      identifier: 'moovin',
      fetching: true,
      errors: [],
      config: {
        product: {
          synchronize: false,
          stockV2: false,
          lookupOnlyStatusActive: false,
          formatColor: 'colors',
          imageType: 'original'
        },
        general: {
          origin: null,
          phoneMask: null
        },
        auth: {
          environment: 'sandbox'
        },
        url: null,
        order: {
          forward: {
            status: []
          }
        }
      },
      imageTypes: [],
      modulesWithExchangeStatuses: [
        {
          identifier: 'netshoes',
          status: {
            approved: null
          }
        }
      ]
    }),
    async mounted () {
      this.loading = true

      await this.fetchOrderStatuses()

      await this.fetchImageTypes()

      const modules = union([
        {
          name: 'Padrão',
          identifier: 'default'
        }
      ], this.modulesInstalled)

      for (let i in modules) {
        const module = modules[i]

        const newConfig = {
          identifier: module.identifier,
          approved: null,
          pending: null,
          canceled: null,
          shipped: null,
          delivered: null,
          refunded: null
        }

        if (this.haveExchangeStatuses(module.identifier)) {
          newConfig.exchange = this.getModuleWithExchangeStatuses(module.identifier).status
        }

        const config = this.getStatusByIdentifier(module.identifier)

        if (!config) {
          this.config.order.forward.status.push(newConfig)
        } else {
          for (let j in Object.keys(newConfig)) {
            const status = Object.keys(newConfig)[j]

            if (config[status] === undefined) {
              config[status] = newConfig[status]
            }
          }
        }
      }

      this.loading = false
    },
    methods: {
      ...mapActions('orderStatuses', [
        'fetch'
      ]),
      async fetchOrderStatuses () {
        this.fetching = true
        this.loading = true
        await this.fetch({
          type: this.type,
          identifier: this.identifier
        })
        this.fetching = false
        this.loading = false
      },
      getError (input) {
        const error = this.errors.find(item => item.input === input)
        return error ? { message: error.message, value: error.value } : { message: null, value: null }
      },
      getStatusByIdentifier (identifier) {
        return this.config.order.forward.status.find(status => status.identifier === identifier)
      },
      getExchangeStatusByIdentifier (identifier) {
        return this.config.order.forward.status.find(status => status.identifier === identifier)['exchange']
      },
      haveExchangeStatuses (identifier) {
        return this.getModuleWithExchangeStatuses(identifier) !== undefined
      },
      getModuleWithExchangeStatuses (identifier) {
        return this.modulesWithExchangeStatuses.find(moduleWithExchangeStatuses => identifier === moduleWithExchangeStatuses.identifier)
      },
      copied () {
        notifier.success('Url copiada com sucesso!', 'Sucesso')
      },
      async fetchImageTypes () {
        try {
          this.imageTypes = await api.moovin.getImageTypes()
        } catch (e) {
          this.imageTypes = []
        }
      }
    },
    computed: {
      ...mapGetters('orderStatuses', [
        'findByModuleTypeAndIdentifier'
      ]),
      ...mapGetters('module', [
        'definitionMarketplacesInstalled'
      ]),
      modulesInstalled () {
        return this.definitionMarketplacesInstalled
      },
      fetched () {
        return Object.keys(this.statusesGroupedByType).length
      },
      statusesGroupedByType () {
        return groupBy(prop('type'), this.findByModuleTypeAndIdentifier(this.type, this.identifier))
      },
      urlNotification () {
        let baseUrl = 'https://backend.placemarket.com.br'
        if (window.location.hostname === 'localhost') {
          baseUrl = 'http://localhost:3000'
        }

        return baseUrl + `/webhook/ecommerce/moovin/notification/${cookie.get('merchant')}`
      }
    },
    components: {
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Moovin.vue?6b8647e2